import { SingleSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="w/ placeholder" />
			<Text semiBold text="w/ placeholder localized" />
			<Text semiBold text="w/o placeholder" />
			<SingleSelect
				options={items}
				placeHolder="Cities"
				value={null}
			/>
			<SingleSelect
				options={items}
				placeHolderRes="Resource"
				placeHolderResParams={["SingleSelect"]}
				value={null}
			/>
			<SingleSelect
				options={items}
				value={null}
			/>
		</CssColumnGrid>
	);
};